import MicroModal from 'micromodal';

document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.micromodal')) {
    MicroModal.init({
      awaitOpenAnimation: true,	// モーダルオープン時にアニメーションを許可
      awaitCloseAnimation: true,	// モーダルクローズ時にアニメーションを許可
      disableScroll: true,			// bodyのスクロールを禁止
      disableFocus: true,			// モーダルオープン時にモーダル内要素にフォーカスさせない
      // onShow: modal => {
      //   console.log(modal.id);
      // }
    });
  }
  // モーダル自身のクリック伝番禁止
  if (document.querySelector('.modal__container')) {
    document.querySelectorAll('.modal__container').forEach(modal => {
      // マウス用の伝搬禁止
      modal.addEventListener('click', function(e) {
        e.stopPropagation();
      });
      // タッチ用の伝搬禁止
      modal.addEventListener('touchstart', function(e) {
        e.stopPropagation();
      });

      // 閉じるボタン
      modal.querySelectorAll('[data-micromodal-close]').forEach(close => {
        close.addEventListener('click', closeElmInModal, false);
        // close.addEventListener('touchstart', closeElmInModal, false);
      })


      function closeElmInModal(e) {
        e.preventDefault();
        e.stopPropagation();
        e.target.closest('.modal__overlay').click();
        // const wrapper = e.target.closest('.micromodal');
        // if (wrapper && wrapper.id) {
        //   MicroModal.close(wrapper.id);
        // }
      }
    });
  }

  //  開いているモーダルから別のモダールに変更
  if (document.querySelector('.js-switch-modal')) {
    document.querySelectorAll('.js-switch-modal').forEach(button => {

      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        try {
          
          // 次に表示させるモーダルID取得
          const newId = e.target.dataset.modal ? e.target.dataset.modal : null;
          if (!newId) {
            throw new Error('次に表示させるモーダルIDが取得できません');
          }

          // 現在のモーダルID取得
          const currentModal = e.target.closest('.micromodal');
          const currentId = currentModal && currentModal.id ? currentModal.id : null;
          if (!currentId) {
            throw new Error('現在のモーダルのIDが取得できません');
          }

          // 現在のモーダルを閉じる
          // MicroModal.close(currentId);
          e.target.closest('.modal__overlay').click();

          // 次のモーダルを表示
          MicroModal.show(newId);

        } catch(err) {
          console.error(err);
        }

      }, false)
    })
  }
})